// « L'agent modifie l'album » + « Demandes du client » (owner, 2026-10-03).
// Worker: routes/clientRequests.ts. A file of its own so lib/api.ts (edited by
// every parallel piece of work) is not touched.
import { apiFetch } from './api';

/** Mirrors worker lib/clientRequests.ts `ItemStatus`. */
export type RequestStatus = 'open' | 'done_owner' | 'done_agent' | 'done' | 'agent_failed' | 'needs_owner';

export interface ClientRequestItem {
  /** `note:<uuid>` or `wa:<message id>`. */
  id: string;
  source: 'preview' | 'whatsapp';
  sourceIds: string[];
  albumIndex: number | null;
  /** The client's page in the 3D preview, when the request named one. */
  page: number | null;
  text: string;
  photos: number;
  /** Of `photos`, how many never reached us (the WhatsApp gateway could not download them). */
  photosLost?: number;
  createdAt: string;
  status: RequestStatus;
  reason: string | null;
  by: string | null;
  at: string | null;
}

export interface AgentEditSwitch {
  on: boolean;
  reason: 'owner' | 'hand_edit' | null;
  since: string | null;
  by: string | null;
  resumedAt: string | null;
}

export interface ClientRequestsSnapshot {
  switch: AgentEditSwitch;
  items: ClientRequestItem[];
  counts: { total: number; open: number; done: number; attention: number };
  /** app_settings.album_editor_agent_mode — the WhatsApp album agent's global mode. */
  album_agent_mode: string;
}

export const clientRequestsApi = {
  get: (shopifyOrderId: string) =>
    apiFetch<ClientRequestsSnapshot>(`/client-requests/${encodeURIComponent(shopifyOrderId)}`),
  setSwitch: (shopifyOrderId: string, on: boolean) =>
    apiFetch<ClientRequestsSnapshot>(`/client-requests/${encodeURIComponent(shopifyOrderId)}/switch`, {
      method: 'POST', body: JSON.stringify({ on }),
    }),
  check: (shopifyOrderId: string, itemId: string, done: boolean) =>
    apiFetch<ClientRequestsSnapshot>(`/client-requests/${encodeURIComponent(shopifyOrderId)}/items`, {
      method: 'POST', body: JSON.stringify({ itemId, done }),
    }),
};
